import { render } from "./DatasetExportModal.vue?vue&type=template&id=2172e0b6&scoped=true"
import script from "./DatasetExportModal.vue?vue&type=script&lang=js"
export * from "./DatasetExportModal.vue?vue&type=script&lang=js"

import "./DatasetExportModal.vue?vue&type=style&index=0&id=2172e0b6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2172e0b6"]])

export default __exports__